// removed by extract-text-webpack-plugin
module.exports = {"iconEditCircle":"iconEditCircle___2Wo1o","iconEdit":"iconEdit___1YPtP","iconPlus":"iconPlus___3fmUl","iconX":"iconX___1QsRo","iconOk":"iconOk___18ijP","iconPlusCircled":"iconPlusCircled___1CUbX","iconMinusCircled":"iconMinusCircled___3SRlU","iconHelpCircled":"iconHelpCircled___2fADr","iconSpin4":"iconSpin4___2JuKV","iconUser":"iconUser___3-KRy","iconCopy":"iconCopy___3J6Dy","iconPaste":"iconPaste___1ApDs","iconScissors":"iconScissors___386pq","animateSpin":"animateSpin___20BLt","spin":"spin___GGaIX"};


//////////////////
// WEBPACK FOOTER
// /app/scss/global.scss
// module id = 5
// module chunks = 0